// src/i18n.js
// i18n setup for exacto React SPA (mirrors nidoux pattern)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English bundled inline as default/fallback
import en from './locales/en.json';

// Lazy-load other locales on demand
const lazyLocales = {
  fr: () => import('./locales/fr.json'),
  de: () => import('./locales/de.json'),
};

async function loadLocale(lng) {
  if (lng === 'en') return; // already bundled
  const loader = lazyLocales[lng];
  if (!loader) return;
  try {
    const mod = await loader();
    i18n.addResourceBundle(lng, 'translation', mod.default || mod, true, true);
  } catch (err) {
    console.warn(`Failed to load locale "${lng}":`, err);
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false, // render immediately with fallback
    },
  });

// Load the detected language if it's not English
if (i18n.language && i18n.language !== 'en') {
  loadLocale(i18n.language);
}

// Load locales on language change
i18n.on('languageChanged', (lng) => {
  loadLocale(lng);
});

export { loadLocale };
export default i18n;
